const blockedEquipment = [
    {
        productId: 0,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 5,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 6,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 1,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 5,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 6,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 2,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 5,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 6,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 3,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: []
            },
            {
                equipmentId: 5,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 6,
                blockedOptions: []
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 4,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: []
            },
            {
                equipmentId: 5,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 6,
                blockedOptions: []
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 5,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: []
            },
            {
                equipmentId: 5,
                blockedOptions: ['ALL']
            },
            {
                equipmentId: 6,
                blockedOptions: []
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 6,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: []
            },
            {
                equipmentId: 5,
                blockedOptions: []
            },
            {
                equipmentId: 6,
                blockedOptions: []
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 7,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: []
            },
            {
                equipmentId: 5,
                blockedOptions: []
            },
            {
                equipmentId: 6,
                blockedOptions: []
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 8,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: []
            },
            {
                equipmentId: 5,
                blockedOptions: []
            },
            {
                equipmentId: 6,
                blockedOptions: []
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
    {
        productId: 9,
        blockedEquipment: [
            {
                equipmentId: 0,
                blockedOptions: []
            },
            {
                equipmentId: 1,
                blockedOptions: []
            },
            {
                equipmentId: 2,
                blockedOptions: []
            },
            {
                equipmentId: 3,
                blockedOptions: []
            },
            {
                equipmentId: 4,
                blockedOptions: []
            },
            {
                equipmentId: 5,
                blockedOptions: []
            },
            {
                equipmentId: 6,
                blockedOptions: []
            },
            {
                equipmentId: 7,
                blockedOptions: []
            },
        ]
    },
];

export default blockedEquipment;